// @flow

import {kebabCase} from 'lodash';
import type {RenderNode as MarkdocRenderNode} from '@markdoc/markdoc';

/**
 * A ContentGroupItem represents an option that can be displayed within a ContentGroup.
 * The title is typically displayed in a selector (for example, a row of tabs) and the
 * content is what will be displayed when the ContentGroupItem is selected.
 */
export class ContentGroupItem {
  id: string;

  title: string;

  content: any;

  info: ?string;

  static fromMarkdocTags(
    tags: Array<MarkdocRenderNode>,
  ): Array<ContentGroupItem> {
    return tags
      .map((tag, index) => {
        if (tag == null || typeof tag === 'string') {
          return null;
        }

        let id = '';
        let title = `Item ${index + 1}`;
        if (tag.attributes) {
          if (typeof tag.attributes.id === 'string') {
            id = tag.attributes.id;
          } else if (typeof tag.attributes.title === 'string') {
            // Make a best guess attempt at inferring the title from the title
            // This value is shown in the URL query param
            id = kebabCase(tag.attributes.title).toLowerCase();
          } else {
            id = `tab${index}`;
          }

          if (typeof tag.attributes.title === 'string') {
            title = tag.attributes.title;
          }
        }

        return new ContentGroupItem(id, title, tag);
      })
      .filter(Boolean);
  }

  constructor(id: string, title: string, content: any) {
    this.id = id;
    this.title = title;
    this.content = content;
  }
}
